import { render, staticRenderFns } from "./InstituteChainEdit.vue?vue&type=template&id=0c70252d"
import script from "./InstituteChainEdit.vue?vue&type=script&lang=js"
export * from "./InstituteChainEdit.vue?vue&type=script&lang=js"
import style0 from "./InstituteChainEdit.vue?vue&type=style&index=0&id=0c70252d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports